<button
  app-button
  buttonType="flat"
  buttonTheme="light"
  [matMenuTriggerFor]="sortActions">
  {{ sort.label }} <fa-icon icon="caret-down" class="ml-1"></fa-icon>
</button>

<mat-menu #sortActions="matMenu">
  <button
    mat-menu-item
    *ngFor="let option of sortOptions"
    (click)="handleSort(option)">
    {{ option.label }}
  </button>
</mat-menu>